jQuery(document).ready(function($){
	let communityGallery = [];
	function buildCommunityGallery(container = null) {
		    const $container = container
        ? $(container)
        : $('.community-hero-container').first();
		const json = $container.attr('data-gallery-images');
		

		if (!json) return [];

		try {
			const imagesgallery = JSON.parse(json);

			return imagesgallery.images.map(item => {

				const type = item.type || 'image';

				if (type === 'video') {
					return {
						src: item.image_url || item.src,
						type: 'html5video',
						caption: item.caption || '',
						thumb: item.poster || item.thumbnail_url,
					};
				}

				return {
					src: item.src || item.image_url,
					type: 'image',
					caption: item.caption || '',
					thumb: item.src || item.image_url
				};
			});
			
		} catch (e) {
			console.error('Invalid gallery JSON', e);
    		return [];
		}
	}

	buildCommunityGallery();

	$('body').on(
		'click',
		'.community-hero-container img[data-fancybox], .community-hero-container .community-hero-grid-launch',
		function (e) {
			e.preventDefault(); 

			const $container = $(this).closest('.community-hero-container');
			const gallery = buildCommunityGallery($container);

			if (!gallery.length) return;

			const index = Number.parseInt($(this).attr('data-index'), 10) || 0;

			Fancybox.show(gallery, {
				startIndex: index
			});
		}
	); 
	/*
	$('body').on('click', 'img[data-fancybox], .community-hero-grid-launch', function (e) {
		e.preventDefault();

		const index = $(this).data('index') || 0;
		console.log(communityGallery);
		Fancybox.show(communityGallery, {
			startIndex: index
		});
	});
	*/
	/*
    if($('img[data-fancybox]').length>0){
        $.each($('img[data-fancybox]'), function(key, el) {
            var thisimg = $(this).attr('src');
            $(this).attr('srcset',thisimg).attr('data-fancybox','gallery');
        });
        Fancybox.bind("[data-fancybox]", {});
    }
    $('body').on('click','.community-hero-grid-launch',function(){
        $('img[data-fancybox]').first().trigger('click');
    });
	*/
});




/*import { store, getElement, getContext } from '@wordpress/interactivity';

store('rvadvcherogrid', {
	actions: {
		open() {
			const { ref } = getElement();
            console.log(ref.closest('[data-wp-interactive]'));
			const state = store();
			state.currentIndex =
				parseInt(ref.dataset.index, 10) || 0;

			state.isOpen = true;
            console.log(state.isOpen);
		},

		close() {
			const { ref } = getElement();
			const state = ref.closest('[data-wp-interactive]').__wp.state;

			state.isOpen = false;
		},

		next() {
			const { ref } = getElement();
			const state = ref.closest('[data-wp-interactive]').__wp.state;

			state.currentIndex =
				(state.currentIndex + 1) %
				state.images.length;
		},

		prev() {
			const { ref } = getElement();
			const state = ref.closest('[data-wp-interactive]').__wp.state;

			state.currentIndex =
				(state.currentIndex - 1 + state.images.length) %
				state.images.length;
		},
	},
});
*/